<form>
    <mat-form-field>
        <mat-label [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-label'">{{formLabel()}}</mat-label>
        <input type="text"
             placeholder="Start typing to search..."
             ariaLabel="{{formLabel()}}"
             matInput
             [value]=""
             [formControl]="autocompleteInnerControl"
             [matAutocomplete]="autocompleteRef"
             [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-input'">
        <mat-autocomplete
            #autocompleteRef="matAutocomplete"
            [displayWith]="displayNameWith"
            (optionSelected)='handleOptionSelected($event.option.value)'>
            @let options = filteredOptions$ | async;
            @for (option of options; track option?.id) {
                <mat-option [value]="option" [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-option'">{{displayNameWith(option)}}</mat-option>
            }
        </mat-autocomplete>
        @if(!!autocompleteInnerControl.value && autocompleteInnerControl.touched && !isObject() && !isRequired() && !emitString()) {
            <mat-hint align="start" [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-hint-no-effect'" >
                <mat-icon>info</mat-icon> Valid option is not selected. This field won't have effect
            </mat-hint>
        }

        @if(autocompleteInnerControl.touched && autocompleteInnerControl.value && hasEnoughChars() && emitString()) {
            <mat-hint align="start" [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-hint-length'">
                <mat-icon>info</mat-icon> More characters will improve results
            </mat-hint>
        }
        @if(autocompleteInnerControl.value && !hideClearButton()){
            <button matSuffix mat-icon-button
                type="button"
                title="Clear autocomplete"
                [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-clear-button'"
                (click)="clearAutocomplete(autocompleteRef); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
            </button>
        }
        @if (autocompleteInnerControl.hasError('invalidModel')) {
            <mat-error [attr.data-testid]="dataTestId()+'-dynamic-autocomplete-error-required'">Type and select an option</mat-error>
        }
    </mat-form-field>
</form>
